﻿const promotions = () => {
    // Disable enter key to force user to use submit-promotion button
    document.querySelectorAll('._js-promotions-input').forEach((element) => {
        element.addEventListener('keydown', (e: Event) => {
            const keyEvent = e as KeyboardEvent;
            if (keyEvent.key === "Enter") {
                e.preventDefault();
            }
        });
    });
}

export const init = () => {
    promotions();
};
